import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function bulkDiscountPct(qty) {
  if (qty >= 12) return 15;
  if (qty >= 6) return 10;
  if (qty >= 3) return 5;
  return 0;
}
// returns { pct, nextTier, unitsToNext } for nudging
export function bulkDiscountInfo(qty) {
  const pct = bulkDiscountPct(qty);
  const tiers = [{ q: 3, p: 5 }, { q: 6, p: 10 }, { q: 12, p: 15 }];
  const next = tiers.find((t) => qty < t.q);
  return { pct, nextTier: next ? next.p : null, unitsToNext: next ? next.q - qty : 0 };
}
